import { render, staticRenderFns } from "./ChooseExpressOrderPopup.vue?vue&type=template&id=5b29c866"
import script from "./ChooseExpressOrderPopup.vue?vue&type=script&lang=js"
export * from "./ChooseExpressOrderPopup.vue?vue&type=script&lang=js"
import style0 from "./ChooseExpressOrderPopup.vue?vue&type=style&index=0&id=5b29c866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports